import React from "react";
import { MapPin, Flame, Snowflake, Utensils, Car } from "lucide-react";
import { useT } from "@/lib/i18n";

const iconMap = {
  "map-pin": MapPin,
  flame: Flame,
  snow: Snowflake,
  utensils: Utensils,
  car: Car,
};

export const TrustBar = () => {
  const { t } = useT();
  return (
    <section aria-label="Trust" className="container-x -mt-8 sm:-mt-12 relative z-10">
      <div
        className="rounded-2xl border border-border bg-card shadow-lifted px-4 sm:px-6 py-4 sm:py-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3"
        data-testid="trust-bar"
      >
        {t.trust.map((item, idx) => {
          const Icon = iconMap[item.icon] || MapPin;
          return (
            <div key={idx} className="flex items-center gap-2 text-sm text-foreground/85">
              <span
                className="inline-flex h-8 w-8 items-center justify-center rounded-full"
                style={{ background: "hsl(var(--secondary))", color: "hsl(var(--pine))" }}
                aria-hidden
              >
                <Icon className="h-4 w-4" />
              </span>
              <span>{item.label}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
};
